//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	angular.module('pphhApp').controller("SimpleBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", SimpleBIController]);
	angular.module('pphhApp').controller("ObraIgBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", ObraIgBIController]);
	angular.module('pphhApp').controller("DmaWaterBodyBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", DmaWaterBodyBIController]);
	angular.module('pphhApp').controller("DmaPressMetaTypeBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", DmaPressMetaTypeBIController]);
	angular.module('pphhApp').controller("DmaSurfaceWbStatusBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", DmaSurfaceWbStatusBIController]);
	angular.module('pphhApp').controller("DmaGroundWbStatusBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", DmaGroundWbStatusBIController]);
	angular.module('pphhApp').controller("DmaSurfaceWbEnvGoalsBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", DmaSurfaceWbEnvGoalsBIController]);
	angular.module('pphhApp').controller("PdMInvestmentBIController", ["$rootScope", "$scope", "$http", "$window", "$mdSidenav", PdMInvestmentBIController]);
	
	var NULL = "(null)";
	
	function BIControllerAdapter($rootScope, $scope, $http, $window, $mdSidenav) {
		
		$scope.dashboard = null;
		$scope.init = init;
		$scope.isParameterValueSelected = isParameterValueSelected;
		$scope.isParameterNullValueSelected = isParameterNullValueSelected;
		$scope.setParameterValue = setParameterValue;
		$scope.setParameterNullValue = setParameterNullValue;
		$scope.selectAll = selectAll;
		$scope.getSelectedParameterValue = getSelectedParameterValue;
		$scope.refreshControlFilterCallback = refreshControlFilterCallback;
		$scope.goto = goto;
		$scope.defaultFiltering = false;
		$scope.applyFilter = applyFilter;
		$scope.applingFilter = false;
		$scope.toggleFilters = toggleFilters;
		
		function init(dashboardName, initParams) {
			if(angular.isUndefined(initParams)) {
				initParams = {};
			}
			
			var req = {
				method: "GET",
				url: _contextPath + "/bi/" + dashboardName,
				params: initParams
			};
	
			$http(req)
			.then(function (response) {
				var dashboard = response.data;
				angular.forEach(dashboard.parameters, function (parameter) {
					if(parameter.defaultValues.length > 0) {
						parameter.values = angular.copy(parameter.defaultValues);
					} else {
						parameter.values = [];
					}
					
					if(parameter.values.length === 0) {
						selectAll(parameter);
					}
				});
				$scope.dashboard = dashboard;
			});
		}
		
		function isParameterValueSelected(parameter, row) {
			return parameter.values.indexOf(row.key) >= 0;
		}
		
		function isParameterNullValueSelected(parameter) {
			return parameter.values.indexOf(NULL) >= 0;
		}
		
		function setParameterValue(parameter, row) {
			var value = row.key;
			addOrSetParameterValue(parameter, value);
		}
		
		function addOrSetParameterValue(parameter, value) {
			
			var currentValues = angular.copy(parameter.values);
			
			if(!parameter.multiple) {
				currentValues = [];
			}
			
			var indexOf = currentValues.indexOf(value);
			if(indexOf >= 0) {
				currentValues.splice(indexOf, 1);
			} else if(value === NULL) {
				currentValues.unshift(value);
			} else {
				currentValues.push(value);
				currentValues.sort(function (a, b) {
					return a - b;
				});
			}
	
			parameter.values = currentValues;
			
			$rootScope.$emit("dsbParamChange", $scope.dashboard, parameter);
		}
		
		function setParameterNullValue(parameter) {
			addOrSetParameterValue(parameter, NULL);
		}
		
		function selectAll(parameter) {
			var values = [];
			
			if(!parameter.multiple) {
				values.push(parameter.source[0].key);
			} else {
				
				if(angular.isUndefined(parameter.$all)) {
					parameter.$all = true;
				} else {
					parameter.$all = !parameter.$all;
				}
		
				if(parameter.$all) {
					angular.forEach(parameter.source, function (row) {
						values.push(row.key);
					});
					values.sort(function (a, b) {
						return a - b;
					});
					
					if(parameter.nullable) {
						values.unshift(NULL);
					}
				}
			}
			
			parameter.values = values;
		}
		
		function getSelectedParameterValue(parameter, value) {
			var found = null;
			angular.forEach(parameter.source, function (pair) {
				if(pair.key === value) {
					found = pair;
				}
			});
	
			return found;
		}
		
		function refreshControlFilterCallback(control, parameter) {
			if(parameter.values.length == 0) {
				return null;
			}
			
			var req = {
				method: "GET",
				url: _contextPath + "/bi/" + $scope.dashboard.name + "/" + control.name,
				params: {}
			};
	
			angular.forEach($scope.dashboard.parameters, function(parameter) {
				if(parameter.values.length > 0) {
					req.params[parameter.name] = parameter.values;
				}
			});
	
			return $http(req)
			.then(function (response) {
				var control = response.data;
				var oldControl = $scope.dashboard.controls[control.name];
				oldControl.fields = control.fields;
				oldControl.source = control.source;
			});
		}
		
		function applyFilter() {
			$scope.applingFilter = true;
			
			var req = {
					method: "GET",
					url: _contextPath + "/bi/" + $scope.dashboard.name,
					params: {}
				};
	
			angular.forEach($scope.dashboard.parameters, function(parameter) {
				if(parameter.values.length > 0) {
					req.params[parameter.name] = parameter.values;
				}
			});
			
			$http(req)
			.then(function (response) {
				var dashboard = response.data;
				
				angular.forEach(dashboard.controls, function (control) {
					$rootScope.$emit("DSB_CONTROL_EXTERNAL_UPDATE", control);
				});
			})
			.finally(function () {
				$scope.applingFilter = false;
			});		
		}
		
		function goto(target) {
			$window.location.href = target;
		}
		
		function toggleFilters() {
			$mdSidenav('left').toggle()
		}
	}
	
	function SimpleBIController($scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $scope, $http, $window, $mdSidenav);
	
		$scope.refreshControlFilterCallback = refreshControlFilterCallback;
		$scope.onSelect = onSelect;
		
		function refreshControlFilterCallback(control, parameter) {
			if(parameter && parameter.name === "dh"
				&& control.name !== "waterBodyCounterDashboardIndicator"
					&& control.name !== "badStateCounterDashboardIndicator"
						&& control.name !== "goodStateCounterDashboardIndicator") {
				return null;
			}
	
			var req = {
				method: "GET",
				url: _contextPath + "/bi/" + $scope.dashboard.name + "/" + control.name,
				params: {}
			};
	
			angular.forEach($scope.dashboard.parameters, function(parameter) {
				if(parameter.value.length > 0) {
					req.params[parameter.name] = parameter.values;
				}
			});
	
			return $http(req)
			.then(function (response) {
				var control = response.data;
				var oldControl = $scope.dashboard.controls[control.name];
				oldControl.fields = control.fields;
				oldControl.source = control.source;
			});
		}
		
		function onSelect(control, selection) {
			if(control.name === "waterBodyCategoriesDashboardControl" && selection[0].column === "nRW") {
				$window.location.href = _contextPath + "/queries/listadoSurfaceWaterBody?ciclo=2&rbd=" + selection[0].row.dh.key;
			}
		}
	}
	
	function ObraIgBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		$scope.defaultFiltering = false;
	}
	
	function DmaWaterBodyBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init; 
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
	
	function DmaPressMetaTypeBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init;
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
	
	function DmaSurfaceWbStatusBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init;
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
	
	function DmaGroundWbStatusBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init;
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
	
	function DmaSurfaceWbEnvGoalsBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init;
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
	
	function PdMInvestmentBIController($rootScope, $scope, $http, $window, $mdSidenav) {
		BIControllerAdapter.call(this, $rootScope, $scope, $http, $window, $mdSidenav);
		
		var superInitMethod = $scope.init;
		$scope.init = init;
		
		function init(dashboardName, versionId) {
			superInitMethod(dashboardName, {"version" : versionId});
		}
	}
})();